import React from 'react';

const DownloadLinkBox = ({ href, filename, fileType, fileSize }) => {

  const getFileIcon = () => {
    switch ((fileType || "").toLowerCase()) {
      case "ipynb":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-hex-ffedd5 dark:bg-fill-orange-700 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-orange-700 dark:text-ink-on-color"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="13" r="2" fill="currentColor"/>
              <path d="M12 11v4M10 13h4" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
        );
      case "csv":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-green-100 dark:bg-fill-green-700 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-green-800 dark:text-ink-on-color"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8 12h8M8 15h8M8 9h8" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
        );
      case "pdf":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-red-100 dark:bg-fill-red-600 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-red-800 dark:text-ink-on-color"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <text
                x="12"
                y="16"
                textAnchor="middle"
                fontSize="6"
                fill="currentColor"
                fontWeight="bold"
                fontFamily="Arial, sans-serif"
              >
                PDF
              </text>
            </svg>
          </div>
        );
      case "xlsx":
      case "xls":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-emerald-100 dark:bg-fill-emerald-700 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-emerald-700 dark:text-ink-on-color"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect x="8" y="10" width="8" height="6" stroke="currentColor" strokeWidth="1" fill="none"/>
              <path d="M10 10v6M14 10v6M8 12h8M8 14h8" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
        );
      case "pptx":
      case "ppt":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-hex-ffedd5 dark:bg-fill-orange-700 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-orange-700 dark:text-ink-on-color"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect x="7" y="11" width="5" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
              <path d="M12 13h3" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
              <path d="M12 15l2 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
            </svg>
          </div>
        );
      case "docx":
      case "doc":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-blue-100 dark:bg-fill-primary rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-blue-600 dark:text-ink-on-primary"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8 12h8M8 15h6M8 9h8" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
        );
      case "txt":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-gray-100 dark:bg-fill-gray-600 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-gray-600 dark:text-ink-white"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8 12h8M8 15h8M8 9h6" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
        );
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "webp":
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-hex-f3e8ff dark:bg-fill-purple-600 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-purple-600 dark:text-ink-on-color"
            >
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="2"
                ry="2"
                stroke="currentColor"
                strokeWidth="2"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
              <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
        );
      default:
        return (
          <div className="flex items-center justify-center w-8 h-8 bg-fill-gray-100 dark:bg-fill-gray-600 rounded-md">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-ink-gray-600 dark:text-ink-white"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M14 2v6h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        );
    }
  };

  const getDisplayName = () => {
    const labels = {
      pdf: "PDF Document",
      pptx: "PowerPoint Presentation",
      ppt: "PowerPoint Presentation",
      xlsx: "Excel Spreadsheet",
      xls: "Excel Spreadsheet",
      csv: "CSV File",
      docx: "Word Document",
      doc: "Word Document",
      txt: "Text File",
      ipynb: "Jupyter Notebook",
      png: "PNG Image",
      jpg: "JPEG Image",
      jpeg: "JPEG Image",
      gif: "GIF Image",
      webp: "WebP Image",
    };
    return labels[fileType?.toLowerCase()] || "Download File";
  };

  const formatFileSize = (size) => {
    if (!size) return null;
    const units = ['B', 'KB', 'MB', 'GB'];
    let unitIndex = 0;
    let sizeValue = parseInt(size);

    while (sizeValue >= 1024 && unitIndex < units.length - 1) {
      sizeValue /= 1024;
      unitIndex++;
    }

    return `${sizeValue.toFixed(unitIndex > 0 ? 1 : 0)} ${units[unitIndex]}`;
  };

  return (
    <a
      href={href}
      download={filename}
      target='_blank'
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 p-2 my-1 bg-fill-hex-fafbfe dark:bg-fill-gray-700 border border-edge-gray-200 dark:border-edge-gray-500 rounded-md hover:bg-fill-gray-50 dark:hover:bg-fill-gray-600 hover:border-edge-gray-300 dark:hover:border-edge-gray-400 transition-all duration-200 no-underline group shadow-sm dark:shadow-lg"
    >
      <div className="flex items-center space-x-2">
        <div className="flex-shrink-0">
          {getFileIcon()}
        </div>
        <div className="flex-1 min-w-0">
          <span className="text-xs font-medium text-ink-gray-900 dark:text-ink-gray-100 truncate">
            {getDisplayName()}
          </span>
          {fileSize && (
            <div className="text-[10px] text-ink-gray-500 dark:text-ink-gray-400">
              {formatFileSize(fileSize)}
            </div>
          )}
        </div>
      </div>
    </a>
  );
};

export default DownloadLinkBox;
